import throttle from 'lib/function/throttle'
import { useState, useEffect } from 'react'

export default function useHasGotToAnchor(element?: Element | null, rootMargin: number = 0, debounceMs: number = 200): boolean {
  const [hasGotToAnchor, setHasGotToAnchor] = useState(false)

  useEffect(() => {
    let cancelled = false

    const handleScroll = () => {
      // throttle's trailing invocation can still fire after cleanup has already run
      // (it's scheduled via its own setTimeout, independent of the listener removal below)
      if (cancelled) {
        return
      }
      if (element) {
        setHasGotToAnchor(element.getBoundingClientRect().top + rootMargin <= 0)
      }
    }

    const throttledHandleScroll = throttle(handleScroll, debounceMs, { leading: true, trailing: true })
    window.addEventListener('scroll', throttledHandleScroll)

    return () => {
      cancelled = true
      window.removeEventListener('scroll', throttledHandleScroll)
    }
  }, [element, debounceMs, rootMargin])

  return hasGotToAnchor
}
